 import { usePostHttp } from "../../http.hook";
import type { IProposalSocials } from "./add-proposal-social.admin.http";

 interface IBody {
   filter: {
     followers: {
       min: number | undefined ;
       max: number | undefined;
     } |  undefined;
     gender:  string[] | undefined;
     genre: string[] |  undefined;
   };
 }

 export interface IResponse {
   campaignProposalSocials: Array<IProposalSocials>;
 }

 export function useProposalSocialApplyFilterAdminHttp() {
   return usePostHttp<IBody, IResponse>({
     path: "/admin/campaigns/proposals/:proposalId/filter",
   });
 }
